import React from 'react';

interface HeroBadgeProps {
  icon: React.ReactNode;
  text: string;
  className?: string;
}

export default function HeroBadge({ icon, text, className = '' }: HeroBadgeProps) {
  return (
    <div
      className={`inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full glass-panel text-white text-xs sm:text-sm font-medium tracking-wide ${className}`}
    >
      {icon}
      <span>{text}</span>
    </div>
  );
}